<div class="universal-competitor-card" #cardElement [ngClass]="{ 'clickable': editMode, 'is-compact': isCompact }">
  <div class="card-content" #cardContent>
    <!-- Фото участника в кружке на сером фоне -->
    <div class="card-photo" (click)="showInfo(competitor.registration.user)">
      <div class="background">
        <img [src]="getPhotoUrl()" alt="{{ competitor.registration.user.name }}" />
        <div class="flag fi fi-{{ competitor.registration.user.citizenship }}"></div>
      </div>
    </div>

    <!-- ФИО, номер, адрес и инфо -->
    <div class="card-member-info">
      <div class="member-name" (click)="showInfo(competitor.registration.user)">{{ competitor.registration.user.name }}</div>
      <div class="member-details">
        <div class="member-num" 
             [ngClass]="{ 'dnf': competitor.DNF > 0, 'track': getTrackerData()?.numberActive }"
             [style.border-color]="getTrackerData()?.numberActive ? getTrackerData()?.numberColor : (getTrackerData()?.numberColor || '#254C74')"
             [style.background]="getTrackerData()?.numberActive ? getTrackerData()?.numberColor : '#f5f5f5'"
             [style.color]="getTrackerData()?.numberActive ? 'white' : '#254C74'"
             (click)="numberEvent()">
          {{ competitor.registration.startNumber }}
        </div>
        <div class="member-city">{{ competitor.registration.user.city }}</div>
        <div class="member-team">{{ competitor.registration.user.team }}</div>
        <div class="member-transport" *ngIf="competitor.registration.info">{{ competitor.registration.info }}</div>
        
        <!-- Кнопка включения/выключения трека -->
        <div class="track-toggle" *ngIf="showTrackToggle && competitor.registration.gpsTracker">
          <div *ngIf="!getTrackerData()?.geoTrack?.sections" class="p-1 clickable" (click)="showTrack()">
            <img src="assets/images/route_off.svg" alt="" class="refresh-icon" />
          </div>
          <div *ngIf="getTrackerData()?.geoTrack?.sections" class="p-1 clickable" (click)="hideTrack()">
            <img src="assets/images/route.svg" alt="" class="refresh-icon" [style.filter]="'drop-shadow(0 0 3px ' + getTrackerData()?.numberColor + ')'" />
          </div>
        </div>
      </div>
    </div>

    <!-- Временные метки и статистика -->
    <div class="card-other-data" (click)="showRaceData()">
    <!-- Позиция -->
    <div class="other-data-line" *ngIf="showPosition && competitor.laps.length > 0 && competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['position'] }}</span>
      <span class="space"></span>
      <span class="position-value">{{ competitor.racePosition }}</span>
    </div>

    <!-- Время старта -->
    <div class="other-data-line" *ngIf="competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['start'] }}</span>
      <span class="space"></span>
      <span>{{ competitor.startTime | date : 'HH:mm:ss' : mapService.timezoneOffsetToString(offset) }}</span>
    </div>

    <!-- Время финиша -->
    <div class="other-data-line" *ngIf="competitor.finTime && competitor.finTime > 0 && competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['finish'] }}</span>
      <span class="space"></span>
      <span>{{ competitor.finTime | date : 'HH:mm:ss' : mapService.timezoneOffsetToString(offset) }}</span>
    </div>

    <!-- Общее время -->
    <div class="other-data-line" *ngIf="competitor.raceTime && competitor.raceTime > 0 && competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['common_time'] }}</span>
      <span class="space"></span>
      <span class="orange">{{ competitor.raceTime | timePeriodPipe : timeFormat }}</span>
    </div>

    <!-- Лучший круг -->
    <div class="other-data-line" *ngIf="competitor.laps.length > 1 && competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['bestLap'] }}</span>
      <span class="space"></span>
      <span *ngIf="competitor.bestTime && competitor.bestTime > 0">{{ competitor.bestTime | timePeriodPipe : timeFormat }}</span>
    </div>

    <!-- Штраф -->
    <div class="other-data-line penalty_link" *ngIf="competitor.penalty && competitor.penalty > 0 && competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['penalty'] }}</span>
      <span class="space"></span>
      <span>{{ competitor.penalty * 1000 | timePeriodPipe : timeFormat }}</span>
    </div>

    <!-- Отставание от лидера -->
    <div class="other-data-line" *ngIf="competitor.deltaLeader && competitor.startTime && competitor.startTime > 0">
      <span>{{ settingsService.translate[settingsService.selectedLang]['behind_the_leader'] }}</span>
      <span class="space"></span>
      <span class="delta-leader">{{ competitor.deltaLeader < 0 ? '' : '+' }}{{ competitor.deltaLeader | timePeriodPipe : timeFormat }}</span>
    </div>

    <!-- Не стартовал -->
    <div class="other-data-line" *ngIf="!competitor.startTime || competitor.startTime <= 0">
      <span class="no-start">{{ noStartText }}</span>
    </div>
  </div>
  </div>

  <!-- Кнопки управления -->
  <div class="controls">
    <!-- Редактирование -->
    <span class="p-1 pi pi-pencil clickable" *ngIf="isOrg || editMode" (click)="editCompetitor()" 
          [title]="settingsService.translate[settingsService.selectedLang]['edit']"></span>
  </div>
</div>
